/**
 * Constants representing different question types
 */
import _t from 'i18n!nls/author-questions';

// TODO: (skohli): Rename to "part"
export const QuestionTypes = {
  MultipleChoice: 'checkbox',
  SingleChoice: 'mcq',
  Code: 'codeExpression',
  Math: 'mathExpression',
  Regex: 'regex',
  Numeric: 'singleNumeric',
  Text: 'textExactMatch',
  ReflectMultipleChoice: 'checkboxReflect',
  ReflectSingleChoice: 'mcqReflect',
  ReflectText: 'reflect',
  Continue: 'continue',
  Poll: 'poll',
  CheckboxPoll: 'checkboxPoll',
  Widget: 'widget',
  QuestionBankQuestionBlock: 'questionBankQuestionBlock',
  TextBlock: 'textBlock',
  CollapsibleTextBlock: 'collapsibleTextBlock',
  MultipleFillableBlanks: 'multipleFillableBlanks',
} as const;

// TODO: (skohli): Rename to "part"
export const getQuestionTypeLabel = (
  type?: (typeof QuestionTypes)[keyof typeof QuestionTypes],
  isEpicEnabled?: boolean
) => {
  const translations = {
    [QuestionTypes.MultipleChoice]: isEpicEnabled ? _t('Multiple correct') : _t('Multiple correct answers'),
    [QuestionTypes.SingleChoice]: isEpicEnabled ? _t('Single correct') : _t('Single correct answer'),
    [QuestionTypes.Code]: _t('Code expression'),
    [QuestionTypes.Math]: _t('Math expression'),
    [QuestionTypes.Regex]: _t('Regular expression'),
    [QuestionTypes.Numeric]: _t('Numeric'),
    [QuestionTypes.Text]: _t('Text match'),
    [QuestionTypes.ReflectMultipleChoice]: _t('Reflective multiple choice'),
    [QuestionTypes.ReflectSingleChoice]: _t('Reflective single choice'),
    [QuestionTypes.ReflectText]: _t('Reflective text answer'),
    [QuestionTypes.Continue]: _t('Pause and Reflect'),
    [QuestionTypes.Poll]: _t('Poll'),
    [QuestionTypes.CheckboxPoll]: _t('Checkbox Poll'),
    [QuestionTypes.Widget]: _t('Plugin Question'),
    [QuestionTypes.QuestionBankQuestionBlock]: _t('Question block from question bank'),
    [QuestionTypes.TextBlock]: _t('Text block'),
    [QuestionTypes.CollapsibleTextBlock]: _t('Collapsible text block'),
    [QuestionTypes.MultipleFillableBlanks]: _t('Multiple dropdowns'), // the author-facing label "Multiple dropdowns" reflects the fact that we currently only support dropdowns at each fillable blank.  Code consistently uses MultipleFillableBlanks apart from this label.
  };
  return type ? translations[type] || '' : '';
};

export default QuestionTypes;
